module.exports = __webpack_public_path__ + "fonts/Inter-100-greek25.eb1153e.woff2";